import List from "@/components/list";
import './table.scss'

const Table = args => {
  const { listeners } = args;
  const RCSelectionChange = listeners["selection-change"] || function () { };
  const RCSelect = listeners["select"] || function () { };
  const RCSelectAll = listeners["select-all"] || function () { };

  const UnitPosition = ({ props: { vo } }) => {
    const unitPosition = vo.row.unitPosition ? vo.row.unitPosition : "--";
    return <span>{unitPosition}</span>;
  };

  const DeptName = ({props: {vo}}) => {
    const item = vo.row;
    const showLineName = item.graduationLineName && item.graduationLineName.length > 0
    return (
      <div class='dept_name'>
        {item.deptName}
        {
          showLineName && <div class='blue_tag'>{item.graduationLineName}</div>
        }
      </div>
    )
  }

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main",
      fixed: 'left',
    },
    {
      label: "姓名",
      prop: "userName",
      minWidth: "100",
      showOverflowTooltip: true
    },
    {
      label: "工作单位",
      minWidth: "150",
      align: 'center',
      prop: "deptName",
      render: (vo) => <DeptName vo={vo} />,
    },
    {
      label: "单位及职务",
      prop: "unitPosition",
      minWidth: "150",
      showOverflowTooltip: true,
      render: vo => <UnitPosition vo={vo} />
    },
    {
      label: "职务层次",
      prop: "positionName",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "职级",
      prop: "positionLevelName",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "性别",
      prop: "sexName",
      minWidth: "100",
      showOverflowTooltip: true
    },
    {
      label: "出生年月",
      prop: "birthday",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "政治面貌",
      prop: "politicsName",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "学历",
      prop: "educationName",
      minWidth: "150",
      showOverflowTooltip: true
    },
  ];
  return (
    <List
      {...args}
      height={382}
      onSelect={RCSelect}
      onSelectAll={RCSelectAll}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
